var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88 15c-.63 0-1.13-.5-1.13-1.13V9A.75.75 0 0 1 2 8.25V7.12C2 6.5 2.5 6 3.13 6h2.22a3.25 3.25 0 0 1-1.47-2.63c0-.2.16-.37.37-.37 1.61 0 3.49 1.22 3.72 3h.06c.23-1.78 2.1-3 3.72-3 .2 0 .38.17.38.38 0 1.01-.56 1.97-1.48 2.62h2.22C13.5 6 14 6.5 14 7.13v1.12c0 .41-.34.75-.75.75v4.88c0 .62-.5 1.12-1.13 1.12H3.88Zm8.25-.75c.2 0 .37-.17.37-.38V9h-3v5.25h2.63Zm-3.38 0V9h-1.5v5.25h1.5Zm-5.25-.38c0 .21.17.38.38.38H6.5V9h-3v4.88Zm9.75-5.62V7.12c0-.2-.17-.37-.38-.37H9.5v1.5h3.75Zm-4.5 0v-1.5h-1.5v1.5h1.5Zm-5.63-1.5c-.2 0-.37.17-.37.38v1.12H6.5v-1.5H3.12Zm8.2-2.97a3 3 0 0 0-2.52 2.2 3 3 0 0 0 2.53-2.2Zm-6.65 0a3 3 0 0 0 2.54 2.2 3 3 0 0 0-2.54-2.2Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.9c24065893856ad1b0463a95315f7f3c.svg";
export { ForwardRef as ReactComponent };